<template>
  <div>
    <h3 style="text-align: center">订单管理</h3>
    <el-tabs
      type="border-card"
      style="width: 1350px; margin: 0 auto"
      @tab-click="handleClick"
    >
      <el-tab-pane label="秒杀订单" style="padding: 20px 40px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-input
              v-model="secUser"
              placeholder="请输入用户名"
              clearable
              size="medium"
              @keyup.enter.native="getSecOrder"
            ></el-input>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="secStime"
              type="date"
              format="yyyy-MM-dd"
              size="medium"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="secEtime"
              type="date"
              size="medium"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getSecOrder"
              >查询</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataSecOrder"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="orderid" label="订单编号"> </el-table-column>
          <el-table-column prop="erpuserid" label="客户编号" width="100px">
          </el-table-column>
          <el-table-column prop="username" label="用户名" width="120px">
          </el-table-column>
          <el-table-column
            prop="zje"
            label="总金额"
            width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="zsje"
            label="销售金额"
            width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xlh2"
            label="序列号"
            width="100px"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="company" label="公司名称"> </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="prop"
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                @click="checkSecDetail(scope.row)"
                >订单详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="secOrderSizeChange"
          @current-change="secOrderCurrentChange"
          :current-page="secOrderIndex"
          :page-sizes="[10, 20]"
          :page-size="secOrderSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="secOrderTotal"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="团购订单" style="padding: 20px 40px">
        <div>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-input
                v-model="TgOrderUsername"
                placeholder="请输入用户名"
                clearable
                size="medium"
                @keyup.enter.native="getTgOrder"
              ></el-input>
            </el-col>
            <el-col :span="2.5">
              <el-select v-model="TgGs" placeholder="请选择公司">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2.5">
              <el-date-picker
                v-model="TgStime"
                type="date"
                format="yyyy-MM-dd"
                size="medium"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="2.5">
              <el-date-picker
                v-model="TgEtime"
                type="date"
                size="medium"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="1.5">
              <el-button type="primary" size="medium" @click="getTgOrder"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-table
            :data="dataTgOrder"
            border
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column
              prop="username"
              label="用户名"
              width="100"
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="erpuserid"
              label="erpID"
              width="100"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="xlh2"
              label="序列号"
              width="100"
              header-align="center"
            >
              <template slot-scope="scope">
                <span style="color: red">{{ scope.row.xlh2 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="zje"
              label="采购金额"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span style="color: red">{{ scope.row.zje }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="zsje"
              label="销售金额"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span style="color: red">{{ scope.row.zsje }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="收货地址"
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="shphone"
              label="联系电话"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="shr"
              label="收货人"
              width="80"
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column
            prop="inserttime"
            label="时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="state" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <div :style="scope.row.state == -1 ? 'color:red;' : ''">
                {{ scope.row.state | TgOrderState(scope.row.state) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="gs" label="公司" width="120" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.gs | TgGs(scope.row.gs) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="xjje"
            label="小结金额"
            width="90"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="bz"
            label="备注"
            width="100"
            header-align="center"
            show-overflow-tooltip
          >
          </el-table-column> -->
            <el-table-column
              prop="inserttime"
              label="时间"
              width="160"
              align="center"
            >
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              width="110"
              fixed="right"
            >
              <template slot-scope="scope">
                <!-- <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditTgOrder(scope.row)"
              ></el-button> -->
                <el-button
                  type="success"
                  @click="checkTgDetail(scope.row)"
                  size="mini"
                  >订单详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="TgOrderSizeChange"
            @current-change="TgOrderCurrentChange"
            :current-page="TgOrderIndex"
            :page-sizes="[10, 20]"
            :page-size="TgOrderSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="TgOrderTotal"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="活动订单" style="padding: 20px 40px">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              v-model="form.orderid"
              placeholder="请输入订单号"
              clearable
              size="medium"
            ></el-input>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="form.stime"
              type="date"
              format="yyyy-MM-dd"
              size="medium"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
              @change="getActivey"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="2.5">
            <el-date-picker
              v-model="form.etime"
              type="date"
              size="medium"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
              @change="getActivey"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" size="medium" @click="getActivey"
              >查询</el-button
            >
          </el-col>
        </el-row>

        <el-table
          :data="activeyList"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            prop="orderid"
            label="订单号"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="erpuserid"
            label="erpID"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="xjje"
            label="采购金额"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.xjje }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="zsl" label="总数量" width="100" align="center">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.zsl }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="收货地址"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系电话"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="shr" label="收货人" width="80" align="center">
          </el-table-column>
          <el-table-column
            prop="inserttime"
            label="时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="110"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                @click="getHdDetail(scope.row)"
                >订单详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="用户管理" style="padding: 20px 40px">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input
              v-model="username"
              placeholder="请输入用户名"
              clearable
              size="medium"
              @keyup.enter.native="getUser"
            ></el-input>
          </el-col>
          <el-col :span="1.5">
            <el-button type="primary" @click="getUser" size="medium"
              >查询</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="success" @click="manageUser" size="medium"
              >添加</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button type="danger" @click="DelChioseUser" size="medium"
              >删除选中</el-button
            >
          </el-col>
        </el-row>
        <el-table
          :data="dataUser"
          style="width: 100%; margin-top: 20px"
          border
          @selection-change="userChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="username" label="用户名"> </el-table-column>
          <el-table-column prop="khmc" label="客户名称"> </el-table-column>
          <el-table-column
            prop="inserttime"
            align="center"
            label="时间"
            width="160"
          >
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="userDelete(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="userSizeChange"
          @current-change="userCurrentChange"
          :current-page="userIndex"
          :page-sizes="[10, 20]"
          :page-size="userSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="userTotal"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!-- <el-dialog
      title="修改订单状态"
      :visible.sync="dialogTgState"
      :width="'600px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="formTgOrder" label-width="110px">
          <el-form-item label="订单状态：">
            <el-radio-group v-model="formTgOrder.state">
              <el-radio :label="0">初始状态</el-radio>
              <el-radio :label="1">已付款</el-radio>
              <el-radio :label="2">生成订单</el-radio>
              <el-radio :label="-1">订单作废</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="formTgOrder.bz"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogTgState = false">取 消</el-button>
        <el-button type="primary" @click="submitState">确 定</el-button>
      </div>
    </el-dialog> -->
    <!-- 团购订单详情 -->
    <el-dialog
      title="团购订单详情"
      :visible.sync="dialogTgDetail"
      :width="'1300px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          :data="dataTgDetail"
          style="width: 100%"
          border
          :row-class-name="tableRowClassNameTg"
        >
          <el-table-column prop="ypmc" label="药品名称" header-align="center">
          </el-table-column>
          <el-table-column prop="cdmc" label="产地名称" header-align="center">
          </el-table-column>
          <el-table-column prop="gg" label="规格" header-align="center">
          </el-table-column>
          <el-table-column prop="ph" label="批号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="dj" label="原价" width="60" align="center">
          </el-table-column>
          <el-table-column
            prop="zsje"
            label="团购单价"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.zsje | addZero(scope.row.zsje) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="buynum"
            label="购买数量"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xjje"
            label="小结金额"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="zsxjje"
            label="团购总金额"
            width="95"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.zsxjje | addZero(scope.row.zsxjje) }}
            </template>
          </el-table-column>
          <el-table-column prop="bz" label="包装" width="60" align="center">
          </el-table-column>
          <el-table-column prop="zbz" label="中包装" width="70" align="center">
          </el-table-column>
          <el-table-column
            prop="scrq2"
            label="生产日期"
            width="90"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="yxq" label="有效期" width="80" align="center">
          </el-table-column>
          <el-table-column prop="pzwh" label="批准文号" header-align="center">
          </el-table-column>
          <el-table-column prop="rq" label="下单时间" header-align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 秒杀订单详情 -->
    <el-dialog
      title="秒杀订单详情"
      :visible.sync="dialogSecDetail"
      :width="'1300px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          :data="dataSecDetail"
          style="width: 100%"
          border
          :row-class-name="tableRowClassNameSec"
        >
          <el-table-column prop="ypmc" label="药品名称" header-align="center">
          </el-table-column>
          <el-table-column prop="cdmc" label="产地名称" header-align="center">
          </el-table-column>
          <el-table-column prop="gg" label="规格" header-align="center">
          </el-table-column>
          <el-table-column prop="ph" label="批号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="dj" label="原价" width="60" align="center">
          </el-table-column>
          <el-table-column
            prop="zsje"
            label="秒杀单价"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.zsje | addZero(scope.row.zsje) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="buynum"
            label="购买数量"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xjje"
            label="小结金额"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="zsxjje"
            label="秒杀总金额"
            width="95"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.zsxjje | addZero(scope.row.zsxjje) }}
            </template>
          </el-table-column>
          <el-table-column prop="bz" label="包装" width="60" align="center">
          </el-table-column>
          <el-table-column prop="zbz" label="中包装" width="70" align="center">
          </el-table-column>
          <el-table-column
            prop="scrq2"
            label="生产日期"
            width="90"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="yxq" label="有效期" width="80" align="center">
          </el-table-column>
          <el-table-column prop="pzwh" label="批准文号" header-align="center">
          </el-table-column>
          <el-table-column prop="rq" label="下单时间" header-align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 添加活动用户 -->
    <el-dialog
      title="添加活动用户"
      :visible.sync="dialogManageUser"
      :width="'400px'"
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="formUser" label-width="80px">
          <el-form-item label="用户名：" class="is-required">
            <el-input v-model="formUser.user"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogManageUser = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 活动详情 -->
    <el-dialog
      title="活动订单详情"
      :visible.sync="dialoghdDetail"
      :width="'1300px'"
      center
      :close-on-click-modal="false"
    >
      <div>
        <el-table :data="activeDetail" style="width: 100%" border>
          <el-table-column prop="ypmc" label="药品名称" align="center">
          </el-table-column>
          <el-table-column prop="cdmc" label="产地名称" align="center">
          </el-table-column>
          <el-table-column prop="gg" label="规格" align="center">
          </el-table-column>
          <el-table-column prop="ph" label="批号" width="120" align="center">
          </el-table-column>
          <el-table-column prop="dj" label="单价" width="80" align="center">
          </el-table-column>
          <el-table-column
            prop="buynum"
            label="购买数量"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="xjje"
            label="小结金额"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="pzwh" label="批准文号" align="center">
          </el-table-column>
          <el-table-column prop="scrq" label="生产日期" align="center">
          </el-table-column>
          <el-table-column prop="yxq" label="有效期" align="center">
          </el-table-column>
          <el-table-column prop="inserttime" label="下单时间" align="center">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      TgStime: "", //查询团购订单的开始时间
      TgEtime: "", //查询团购订单的结束时间
      TgOrderIndex: 1,
      TgOrderSize: 20,
      TgOrderTotal: 0,
      TgOrderUsername: "", //查询团购订单的用户名
      dataTgOrder: [], //团购订单数据
      dialogTgOrder: false,

      activeyList: [], // 活动订单数据
      activeDetail: [],
      dialoghdDetail: false,
      form: {
        pageIndex: 1,
        pageSize: 20,
        // keys: "",
        stime: "",
        etime: "",
        orderid: "",
      }, // 活动订单参数

      TgGs: -1,
      options: [
        {
          value: -1,
          label: "全部（请选择公司）",
        },
        {
          value: 0,
          label: "电子商务公司",
        },
        {
          value: 2,
          label: "工业公司",
        },
        {
          value: 3,
          label: "西药公司",
        },
        {
          value: 4,
          label: "新特药公司",
        },
        {
          value: 5,
          label: "药品公司",
        },
        {
          value: 6,
          label: "药材公司",
        },
      ],
      formTgOrder: {
        id: 0,
        state: 0,
        bz: "",
      },
      dialogTgState: false, //修改团购状态的开关
      dialogTgDetail: false,
      dataTgDetail: [],
      secUser: "",
      secStime: "",
      secEtime: "",
      dataSecOrder: [],
      secOrderIndex: 1, //秒杀订单Index
      secOrderSize: 20, //秒杀订单Size
      secOrderTotal: 0, //秒杀订单总数
      dialogSecDetail: false, //秒杀订单详情的弹出框
      dataSecDetail: [], //秒杀订单详情列表
      username: "", //秒杀用户的用户名
      userIndex: 1, //用户的Index
      userSize: 20, //用户的Size
      userTotal: 0, //用户的总数
      dataUser: [], //活动用户的列表
      dialogManageUser: false, //添加活动用户的弹出框
      formUser: {
        user: "",
      },
      userSelection: [], //活动用户选中的id数据
    };
  },
  filters: {
    TgOrderState(state) {
      if (state == "0") {
        return "初始状态";
      } else if (state == "1") {
        return "已付款";
      } else if (state == "2") {
        return "已生成订单";
      } else if (state == "-1") {
        return "已作废";
      }
    },
    TgGs(gs) {
      if (gs == 0) {
        return "电子商务公司";
      } else if (gs == 2) {
        return "工业公司";
      } else if (gs == 3) {
        return "西药公司";
      } else if (gs == 4) {
        return "新特药公司";
      } else if (gs == 5) {
        return "药品公司";
      } else if (gs == 6) {
        return "药材公司";
      }
    },
    addZero(val) {
      val = val + "";
      if (val.substr(0, 1) == ".") {
        val = "0" + val;
      }
      return Number(val);
    },
  },
  mounted() {
    this.getSecOrder();
  },
  methods: {
    dateFormat(Date, fmt) {
      var o = {
        "M+": Date.getMonth() + 1, //月份
        "d+": Date.getDate(), //日
        "H+": Date.getHours(), //小时
        "m+": Date.getMinutes(), //分
        "s+": Date.getSeconds(), //秒
        "q+": Math.floor((Date.getMonth() + 3) / 3), //季度
        S: Date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (Date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    handleClick(tab) {
      //
      if (tab.label == "秒杀订单") {
        this.getSecOrder();
      } else if (tab.label == "团购订单") {
        this.getTgOrder();
      } else if (tab.label == "活动订单") {
        this.getActivey();
      } else if (tab.label == "用户管理") {
        this.getUser();
      }
    },

    getActivey() {
      this.form.pageIndex = 1;
      this.searchActivey();
    },

    // 获取活动订单
    searchActivey() {
      let startDate = new Date();
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
      let startTime = this.dateFormat(startDate, "yyyy-MM-dd");
      this.form.stime = this.form.stime ? this.form.stime : startTime;
      this.form.etime = this.form.etime
        ? this.form.etime
        : this.dateFormat(new Date(), "yyyy-MM-dd");
      if (this.form.stime > this.form.etime) {
        return this.$message({
          message: "开始日期不可大于结束日期",
          type: "warning",
        });
      }

      this.$http
        .post("DsApi/GetSearchList", {
          action: "cjdrugorders",
          ...this.form,
        })
        .then((res) => {
          if (res.data.isok) {
            this.activeyList = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },

    getTgOrder() {
      this.TgOrderIndex = 1;
      this.searchTgOrder();
    },

    // 获取团购订单列表
    searchTgOrder() {
      let startDate = new Date();
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
      let startTime = this.dateFormat(startDate, "yyyy-MM-dd");
      this.TgStime = this.TgStime ? this.TgStime : startTime;
      this.TgEtime = this.TgEtime
        ? this.TgEtime
        : this.dateFormat(new Date(), "yyyy-MM-dd");
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.TgOrderIndex,
          pageSize: this.TgOrderSize,
          keys: this.TgOrderUsername,
          stime: this.TgStime,
          etime: this.TgEtime,
          action: "tgorders_y",
          gs: this.TgGs,
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataTgOrder = res.data.data;
            this.TgOrderTotal = res.data.recount;
          }
        });
    },
    //修改订单状态
    handleEditTgOrder(rows) {
      this.formTgOrder.id = rows.id;
      this.formTgOrder.state = rows.state;
      this.formTgOrder.bz = rows.bz;
      this.dialogTgState = true;
    },
    // 修改团购订单的提交按钮
    submitState() {
      this.$http.post("DsApi/UpdateTgOrders", this.formTgOrder).then((res) => {
        if (res.data.isok) {
          this.$message.success(res.data.message);
          this.dialogTgState = false;
          this.searchTgOrder();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    getHdDetail(row) {
      this.$http
        .post("DsApi/GetSearchList", {
          action: "cjdrugordersdetail",
          orderid: row.orderid,
        })
        .then((res) => {
          if (res.data.isok) {
            this.dialoghdDetail = true;
            this.activeDetail = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },

    checkTgDetail(rows) {
      this.$http
        .post("DsApi/GetSearchList", {
          orderid: rows.orderid,
          isms: 2,
          action: "orders_detail",
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataTgDetail = res.data.data;
            this.dialogTgDetail = true;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 团购订单详情判断
    tableRowClassNameTg({ row, rowIndex }) {
      //
      if (row.isms != 0) {
        return "danger-row";
      }
    },
    //获取秒杀订单
    getSecOrder() {
      this.secOrderIndex = 1;
      this.searchSecOrder();
    },
    searchSecOrder() {
      let startDate = new Date();
      startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
      let startTime = this.dateFormat(startDate, "yyyy-MM-dd");
      this.secStime = this.secStime ? this.secStime : startTime;
      this.secEtime = this.secEtime
        ? this.secEtime
        : this.dateFormat(new Date(), "yyyy-MM-dd");
      this.$http
        .post("DsApi/GetSearchList", {
          pageIndex: this.secOrderIndex,
          pageSize: this.secOrderSize,
          keys: this.secUser,
          stime: this.secStime,
          etime: this.secEtime,
          action: "msorders_y",
        })
        .then((res) => {
          if (res.data.isok) {
            //
            this.dataSecOrder = res.data.data;
            this.secOrderTotal = res.data.recount;
          }
        });
    },
    // 获取秒杀订单详情
    checkSecDetail(rows) {
      this.$http
        .post("DsApi/GetSearchList", {
          orderid: rows.orderid,
          isms: 1,
          action: "orders_detail",
        })
        .then((res) => {
          if (res.data.isok) {
            this.dataSecDetail = res.data.data;
            this.dialogSecDetail = true;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //秒杀详情判断
    tableRowClassNameSec({ row, rowIndex }) {
      if (row.isms != 0) {
        return "danger-row";
      }
    },
    // 搜索用户
    getUser() {
      this.userIndex = 1;
      this.searchUser();
    },
    // 查询用户
    searchUser() {
      this.$http
        .post("DsApi/GetSearchList", {
          keys: this.username,
          pageIndex: this.userIndex,
          pageSize: this.userSize,
          action: "msuser_y",
        })
        .then((res) => {
          //
          if (res.data.isok) {
            this.dataUser = res.data.data;
            this.userTotal = res.data.recount;
          }
        });
    },
    // 添加活动用户
    manageUser() {
      this.formUser.user = "";
      this.dialogManageUser = true;
    },
    // 确认添加用户
    confirm() {
      this.$http.post("DsApi/AddMsUser", this.formUser).then((res) => {
        if (res.data.isok) {
          this.$message.success(res.data.message);
          this.dialogManageUser = false;
          this.searchUser();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 删除选中用户
    DelChioseUser() {
      if (this.userSelection.length == 0) {
        this.$message.error("对不起！您还未选中秒杀用户");
      } else {
        let id = this.userSelection.join();
        this.$confirm("此操作将永久删除这些秒杀用户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.DelUser(id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 删除用户
    userDelete(rows) {
      this.$confirm("此操作将会永久删除这个秒杀用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let id = rows.id;
          this.DelUser(id + "");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 删除用户
    DelUser(id) {
      this.$http
        .post("DsApi/DelMsUser", {
          id,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.searchUser();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 活动用户列表被选中时
    userChange(val) {
      this.userSelection = val.map((item) => {
        return item.id;
      });
    },
    //团购订单Size发生变化时
    TgOrderSizeChange(val) {
      this.TgOrderSize = val;
      this.searchTgOrder();
    },
    //团购订单Index发生变化时
    TgOrderCurrentChange(val) {
      this.TgOrderIndex = val;
      this.searchTgOrder();
    },
    // 秒杀订单Size发生改变时
    secOrderSizeChange(val) {
      this.secOrderSize = val;
      this.searchSecOrder();
    },
    // 秒杀订单Index发生改变
    secOrderCurrentChange(val) {
      this.secOrderIndex = val;
      this.searchSecOrder();
    },
    // 秒杀用户Size发生改变时
    userSizeChange(val) {
      this.userSize = val;
      this.searchUser();
    },
    // 秒杀用户Index发生改变
    userCurrentChange(val) {
      this.userIndex = val;
      this.searchUser();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-pagination {
  text-align: center;
  margin-top: 15px;
}
/deep/ .el-table th {
  background-color: #eef1f6;
}
/deep/ tr td {
  font-size: 12px;
}
/deep/ .el-table .danger-row {
  background: #f9ebeb;
}
</style>


// WEBPACK FOOTER //
// src/components/TgOrder.vue